import { render, staticRenderFns } from "./insectSituation.vue?vue&type=template&id=fe363f08&scoped=true"
import script from "./insectSituation.vue?vue&type=script&lang=js"
export * from "./insectSituation.vue?vue&type=script&lang=js"
import style0 from "./insectSituation.vue?vue&type=style&index=0&id=fe363f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe363f08",
  null
  
)

export default component.exports